export type StickerSize = 's' | 'm' | 'l' | 'xl';

/** Extra vertical shelf padding on one side of a protruding title line. */
export interface ShelfPadding {
  top: number;
  bottom: number;
}

/** Extra shelf padding per title line when that line protrudes past a neighbour. */
export interface PadShelfYByLine {
  first: ShelfPadding;
  middle: ShelfPadding;
  last: ShelfPadding;
}

export interface StickerSizePreset {
  font: number;
  lineHeight: number;
  /** Uniform inner padding between shape edge and title/label. */
  padding: number;
  padShelfY: PadShelfYByLine;
  radius: number;
  /** Pill label total height (incl. border), scaled from XL design (56px). */
  labelHeight: number;
  /** Pill label font size; ~50% of title font at XL (32px). */
  labelFont: number;
  labelPaddingInline: number;
}

/** Typography and shape padding per campaign size. */
export const STICKER_SIZE_PRESETS: Record<StickerSize, StickerSizePreset> = {
  xl: {
    font: 64,
    // Slightly tighter than design block height so title lines sit closer.
    lineHeight: 1.15,
    padding: 32,
    padShelfY: {
      first: { top: 0, bottom: 6 },
      middle: { top: 12, bottom: 8 },
      last: { top: 18, bottom: 0 },
    },
    radius: 16,
    labelHeight: 60,
    labelFont: 32,
    labelPaddingInline: 24,
  },
  l: {
    font: 40,
    lineHeight: 1.0,
    padding: 24,
    padShelfY: {
      first: { top: 0, bottom: 8 },
      middle: { top: 12, bottom: 8 },
      last: { top: 16, bottom: 0 },
    },
    radius: 16,
    labelHeight: 40,
    labelFont: 20,
    labelPaddingInline: 16,
  },
  m: {
    font: 32,
    lineHeight: 1.05,
    padding: 20,
    padShelfY: {
      first: { top: 0, bottom: 8 },
      middle: { top: 12, bottom: 8 },
      last: { top: 16, bottom: 0 },
    },
    radius: 16,
    labelHeight: 32,
    labelFont: 16,
    labelPaddingInline: 14,
  },
  s: {
    font: 24,
    lineHeight: 1.15,
    padding: 20,
    padShelfY: {
      first: { top: 0, bottom: 6 },
      middle: { top: 10, bottom: 6 },
      last: { top: 14, bottom: 0 },
    },
    radius: 16,
    labelHeight: 24,
    labelFont: 12,
    labelPaddingInline: 12,
  },
};
